var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3C4.67725 3 3 4.68583 3 6.7552C3 7.74919 3.39468 8.70534 4.09835 9.40901L8.34099 13.6516C8.76294 14.0736 9 14.6459 9 15.2426V21.25C9 21.4844 9.10956 21.7053 9.29615 21.8471C9.48275 21.9889 9.72491 22.0354 9.95073 21.9726L14.4507 20.7226C14.7753 20.6325 15 20.3369 15 20V15.2426C15 14.6459 15.2371 14.0736 15.659 13.6516L19.9016 9.40901C20.6053 8.70535 21 7.74921 21 6.7552C21 4.68584 19.3228 3 17.25 3H6.75ZM4.5 6.7552C4.5 5.51087 5.50905 4.5 6.75 4.5H17.25C18.491 4.5 19.5 5.51086 19.5 6.7552C19.5 7.35249 19.2625 7.92679 18.841 8.34835L14.5984 12.591C13.8951 13.2942 13.5 14.2481 13.5 15.2426V19.4299L10.5 20.2633V15.2426C10.5 14.2481 10.1049 13.2942 9.40165 12.591L5.15901 8.34835C4.73746 7.9268 4.5 7.35251 4.5 6.7552Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter1);
export default __webpack_public_path__ + "static/media/filter-1.4ea4088f32a6c950b6744379729ba0b7.svg";
export { ForwardRef as ReactComponent };